import type { GetStaticProps, InferGetStaticPropsType, NextPage } from "next";
import Link from "next/link";
import { BaseContext } from "next/dist/shared/lib/utils";
import { getAllPosts } from "../lib/api";
import markdownToHtml from "../lib/markdownToHtml";
import styled from "@emotion/styled";
import ReactPaginate from "react-paginate";
import { useEffect, useState } from "react";
import { PostPreview } from "../components/news/postPreview";
import { H1 } from "../components/common/h1";
import { PostContainer } from "../components/news/postContainer";
import { useRouter } from "next/router";
import { PostSection } from "../components/styles/postSection";
import Head from "next/head";
import { motion } from "framer-motion";
interface Props {
	allPosts: Array<Object>;
}

interface Pagination {
	selected: number;
}

const Jobs: NextPage = ({
	allPosts,
	postLength,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
	const router = useRouter();

	const Container = styled("main")`
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		max-width: 1000px;
		header {
			align-self: flex-start;
			margin: 0 20px;
		}
		.post-container {
			display: flex;
			flex-direction: column;
			max-width: 100%;
			padding: 0 20px;
		}

		.section-image {
			width: 100%;
			min-height: 50px;
			object-fit: cover;
		}
	`;

	return (
		<>
			<Head>
				<title>Jobs – Moonsworth</title>
			</Head>
			<Container>
				<header>
					<H1 tagline="Work with us.">Job Openings.</H1>
				</header>
				<div className="post-container">
					{allPosts.map((post: any, index: number) => (
						<motion.div
							key={post.slug}
							initial={{ opacity: 0, y: -50 }}
							animate={{
								opacity: 1,
								y: 0,
							}}
							transition={{
								duration: 0.5,
								delay: 0.1 * index,
							}}
						>
							<PostSection
								dangerouslySetInnerHTML={{
									__html: post.content,
								}}
							/>
						</motion.div>
					))}
				</div>
			</Container>
		</>
	);
};

export const getStaticProps: GetStaticProps = async (context: BaseContext) => {
	const allCategories = [];
	let allPosts: any = getAllPosts(["slug", "content"], "jobs");

	for (let i = 0; i < allPosts.length; i++) {
		allPosts[i].content = (await markdownToHtml(allPosts[i].content)) || "";
	}

	return {
		props: { allPosts, postLength: allPosts.length },
	};
};

export default Jobs;
